import * as React from 'react';
import { Button, UIHeading2, UIText1 } from '@cian/ui-kit';
import imageFail from './assets/fail.png';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Fail(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsxs(UIHeading2, {
      children: ["\u041E\u0439!", /*#__PURE__*/_jsx("br", {}), "\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0441\u044F \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C", /*#__PURE__*/_jsx("div", {
        className: styles['icon'],
        children: /*#__PURE__*/_jsx("img", {
          width: "28",
          height: "28",
          src: imageFail
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles['description'],
      children: /*#__PURE__*/_jsx(UIText1, {
        children: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u044D\u0442\u043E \u043F\u043E\u0437\u0436\u0435"
      })
    }), /*#__PURE__*/_jsx(Button, {
      size: "M",
      onClick: onClick,
      children: "\u0425\u043E\u0440\u043E\u0448\u043E"
    })]
  });
}